import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";
import { isEmpty, toLower, toString } from "lodash";
import {
  Dropdown,
  InputGroup,
  Form,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import LoaderWrapper from "../LoaderWrapper";
import AddToolTip from "../AddToolTip";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormControlSearch from "../FormControlSearch";
import FormControl from "../FormControl";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { useDeepEffect } from "../../abstracts";

let typeAheadChangeTimeout = null;
const SearchableList = forwardRef((props, ref) => {
  const {
    options = [],
    onSelect,
    label,
    placeholder = "Search",
    isNotTypeAhead,
    disabled,
    selectedValue,
    height,
    width = "300px",
    onTypeAheadChange,
    typeAheadChangeDelay = 500,
    isLoading,
    defaultLabel,
    isSelectedByDefault,
    isFieldClear = false,
    className = "",
    page,
  } = props;
  const popupWrapper = useRef(null);
  const popupSearchBox = useRef(null);
  const [query, setQuery] = useState("");

  useImperativeHandle(ref, () => ({
    tiggerOnSelect(value, label) {
      onSelect(value, label);
    },
  }));

  useEffect(() => {
    const popupSearchBoxDom = popupSearchBox.current;
    if (!isNotTypeAhead && popupSearchBoxDom) {
      window.setTimeout(() => {
        popupSearchBoxDom.focus();
      }, 100);
    }

    if (isSelectedByDefault && options.length === 1) {
      options.map(({ value, label }) => {
        onSelect(value, label);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [showTooltip, setShowTooltip] = useState(false);
  const handleScroll = () => {
    setShowTooltip(null);

    const searchableListElement = document.querySelector(".searchable-list");
    searchableListElement.addEventListener("scroll", handleScroll);
    return () => {
      searchableListElement.removeEventListener("scroll", handleScroll);
    };
  };
  const keyDown = (e) => {
    if (e.keyCode == 32) {
      e.preventDefault();
      e.target.value += " ";
    }
  };
  const changeHandler = (e) => {
    const val = e;
    setQuery(val);

    window.clearInterval(typeAheadChangeTimeout);
    typeAheadChangeTimeout = window.setTimeout(() => {
      if (onTypeAheadChange) {
        onTypeAheadChange(val);
      }
    }, typeAheadChangeDelay);
  };

  const popUpOptionsUI = options.map((option) => {
    const { value, label } = option;

    if (
      query.length !== 0 &&
      !label
        ?.toString()
        .trim()
        .toLocaleLowerCase()
        .includes(query.toLocaleLowerCase())
    ) {
      return null;
    }
    const checked = selectedValue === value;

    if (option.break) {
      return <br />;
    }

    return (
      <Dropdown.Item
        ref={ref}
        key={value}
        as="button"
        type="button"
        onClick={() => onSelect(value, label)}
        className={checked ? "selected" : ""}
        data-attr={toLower(value)}
        data-attr-label={toLower(label)}
        disabled={disabled}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <OverlayTrigger
          overlay={
            showTooltip === true ? (
              <Tooltip style={{ zIndex: 999999 }}>{label}</Tooltip>
            ) : (
              <div></div>
            )
          }
        >
          <div
            style={{
              textOverflow: "ellipsis",
              maxWidth: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </div>
        </OverlayTrigger>
      </Dropdown.Item>
    );
  });
  const popUpOptionsPlanList = options.map((option) => {
    const { value, label, label1 } = option;
    if (
      query.length !== 0 &&
      !toString(`${label1}${label}`)
        ?.trim()
        .toLocaleLowerCase()
        .includes(query.toLocaleLowerCase())
    ) {
      return null;
    }
    const checked = selectedValue === label;

    if (option.break) {
      return <br />;
    }

    return (
      <>
        <Dropdown.Item
          ref={ref}
          key={value}
          as="button"
          type="button"
          onClick={() => onSelect(value, label)}
          className={`d-flex justify-content-space-between`}
          data-attr={toLower(value)}
          data-attr-label={toLower(label)}
          data-attr-label1={toLower(label1)}
          disabled={disabled}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <div className="d-flex flex-column">
            {/* <AddToolTip className="font-weight-600" name={label}></AddToolTip>
            <AddToolTip name={label1}></AddToolTip> */}
            <OverlayTrigger
              overlay={
                showTooltip === true ? (
                  <Tooltip style={{ zIndex: 999999 }}>{label}</Tooltip>
                ) : (
                  <div></div>
                )
              }
            >
              <div
                style={{
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {label}
              </div>
            </OverlayTrigger>
            <OverlayTrigger
              overlay={
                showTooltip === true ? (
                  <Tooltip style={{ zIndex: 999999 }}>{label1}</Tooltip>
                ) : (
                  <div></div>
                )
              }
            >
              <div
                style={{
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {label1}
              </div>
            </OverlayTrigger>
          </div>
          <div className="d-flex flex-row" style={{ paddingTop: "13px" }}>
            {checked && (
              <FontAwesomeIcon icon={faCheck} className="payroll-btns" />
            )}
          </div>
        </Dropdown.Item>
        <Dropdown.Divider />
      </>
    );
  });
  const CheckPopupOptionsAreEmpty = (arr) => arr.every((val) => val === null);
  const transformedDefaultLabel = `Select a ${defaultLabel}`;
  const classname = isFieldClear
    ? "searsearchable-list-wrapper-var"
    : "searchable-list-wrapper";
  const sr = isFieldClear
    ? "searchable-list-input form-group1"
    : "searchable-list-input";
  const la = isFieldClear
    ? "searchable-list-label pl-3"
    : "searchable-list-label";
  const Width = isFieldClear ? "270px" : width;
  return (
    <LoaderWrapper isLoading={isLoading} className="h-100">
      <div ref={popupWrapper} className={`${classname} border-color-searchbar`}>
        <Form.Group className={sr}>
          <Form.Label className={la}>
            {label || transformedDefaultLabel}
          </Form.Label>
          {!isNotTypeAhead &&
            (isFieldClear ? (
              // <InputGroup>
              //   <Form.Control
              //     ref={popupSearchBox}
              //     className="searchable-list-input-text"
              //     placeholder={placeholder}
              //     autoFocus
              //     type="text"
              //     value={query}
              //     onChange={(e) => changeHandler(e.target.value)}
              //     onKeyDown={keyDown}
              //   />
              //   <InputGroup.Append backgroundColor="#ffffff">
              //     <InputGroup.Text onClick={() => changeHandler("")}>
              //       <FontAwesomeIcon
              //         icon={faTimes}
              //         //color={"#ff0000"}
              //         // style={{ marginLeft: "25px" }}
              //       />
              //     </InputGroup.Text>
              //   </InputGroup.Append>
              // </InputGroup>
              <FormControl>
                <FormControlSearch
                  placeholder={placeholder}
                  className="searchable-list-input-text"
                  autoFocus
                  type="text"
                  size="xs"
                  onChange={(e) => changeHandler(e.target.value)}
                  onKeyDown={keyDown}
                />
              </FormControl>
            ) : (
              <InputGroup>
                <Form.Control
                  ref={popupSearchBox}
                  className="searchable-list-input-text"
                  placeholder={placeholder}
                  autoFocus
                  type="text"
                  value={query}
                  onChange={(e) => changeHandler(e.target.value)}
                  onKeyDown={keyDown}
                />
              </InputGroup>
            ))}
        </Form.Group>
        <div
          className={`searchable-list overflow-y-auto ${className}`}
          style={{
            height: height,
            width: Width,
            justifyContent: "space-between",
            marginRight: "0px !important",
          }}
          onScroll={handleScroll}
        >
          {!isLoading &&
            (isEmpty(options) ||
              (page !== "managePayroll" &&
                CheckPopupOptionsAreEmpty(popUpOptionsUI)) ||
              (page == "managePayroll" &&
                CheckPopupOptionsAreEmpty(popUpOptionsPlanList))) && (
              <div className="text-center">No data found</div>
            )}
          {page == "managePayroll" ? popUpOptionsPlanList : popUpOptionsUI}
        </div>
      </div>
    </LoaderWrapper>
  );
});
export default SearchableList;
